import React from 'react';
import skillBanner from '../../../images/skillBanner2.png'
import img1 from '../../../images/skills/1.png';
import img2 from '../../../images/skills/2.png';
import img3 from '../../../images/skills/3.png';
import img4 from '../../../images/skills/4.png';
import img5 from '../../../images/skills/5.png';
import img6 from '../../../images/skills/6.png';
import img7 from '../../../images/skills/7.png';
import img8 from '../../../images/skills/8.png';


const Skills = () => {
    return (
        <div id="skills" className="container w-75 py-5 mt-5">
            <h2 className="mb-5">My Expertise</h2>
            <div className="row">
                <div className='col-12 col-md-6 col-lg-4 px-5'>
                    <img src={skillBanner} className="w-100" alt="" />
                </div>
                <div className='col-12 col-md-6 col-lg-8'>
                    <div className="row row-cols-1 row-cols-lg-4 g-4 g-lg-3">
                        <div className="col">
                            <div className="p-1 d-flex align-items-center">
                                <img src={img1} className="img-fluid" alt="" />
                                <div className="text-start ms-1">
                                    <h5>HTML5</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="p-1 d-flex align-items-center">
                                <img src={img2} className="img-fluid" alt="" />
                                <div className="text-start ms-1">
                                    <h5>CSS3</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="p-1 d-flex align-items-center">
                                <img src={img3} className="img-fluid" alt="" />
                                <div className="text-start ms-1">
                                    <h5>JavaScript</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="p-1 d-flex align-items-center">
                                <img src={img4} className="img-fluid" alt="" />
                                <div className="text-start ms-1">
                                    <h5>React</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="p-1 d-flex align-items-center">
                                <img src={img5} className="img-fluid" alt="" />
                                <div className="text-start ms-1">
                                    <h5>Bootstrap</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="p-1 d-flex align-items-center">
                                <img src={img6} className="img-fluid" alt="" />
                                <div className="text-start ms-1">
                                    <h5>Firebase</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="p-1 d-flex align-items-center">
                                <img src={img7} className="img-fluid" alt="" />
                                <div className="text-start ms-1">
                                    <h5>Node JS</h5>
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="p-1 d-flex align-items-center">
                                <img src={img8} className="img-fluid" alt="" />
                                <div className="text-start ms-1">
                                    <h5>MongoDB</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;